<template>
  <v-list dense class="pt-0">
    <v-list-tile v-if="currentPeriod" :to="{name: 'plan', params: {period: currentPeriod.id}}"
                 :class="period === currentPeriod.id ? 'primary--text v-list__tile--active' : ''">
      <v-list-tile-action>
        <v-icon>calendar_today</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title style="font-weight: bold; font-size: 115%;">{{ currentPeriod.title }}</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <hr>
    <hr>
    <v-list-tile>
      <v-list-tile-content>
        <h3>Предыдущие года:</h3>
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile v-for="item in sideMenuItems" :key="item.id" :to="{name: 'plan', params: {period: item.id}}">
      <v-list-tile-action>
        <v-icon>calendar_today</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data: () => ({
    currentPeriod: ''
  }),
  computed: {
    ...mapState('periods', {
      periods: state => state.periods
    }),
    sideMenuItems () {
      return Object.values(this.periods)
          .filter(period => period.id !== this.settings['current-period'])
          .sort((a, b) => {
            const _a = new Date(a.start)
            const _b = new Date(b.start)

            if (_a === _b) {
              return 0
            }

            return (_a > _b) ? -1 : 1
          })
    },
    period() {
      return this.$route.params.period
    },
    settings() {
      return this.$store.getters.settings
    }
  },
  mounted() {
    this.loadPeriods()
  },
  methods: {
    async loadPeriods() {
      try {
        await this.loadSettings()
        await this.$store.dispatch('periods/getPeriods')
        this.currentPeriod = Object.values(this.periods).find((period) => period.id === this.settings['current-period'])
      } catch (error) {
        this.$events.$emit('notify', {
          message: error.message,
          type: 'error'
        })
      }
    },
    async loadSettings() {
      const options = [
        'current-period'
      ]
      await this.$store.dispatch('loadSettings', { options })
    },
  }
}
</script>
